// navConfig.ts or similar
import { ROUTE_KEYS } from 'utils/constants';
import { ReactComponent as BrandDetailsIcon } from 'assets/icons/brand-details.svg';
import { ReactComponent as OpeningTimeIcon } from 'assets/icons/opening-time.svg';

export const getBlogDetailsNav = (search = '') => [
  {
    title: 'Article Body',
    link: `${ROUTE_KEYS.CREATE_BLOG_ROUTE_TAG}/${ROUTE_KEYS.CREATE_BLOG_BODY}${search}`,
    Icon: BrandDetailsIcon
  },
  {
    title: 'Image & Tags',
    link: `${ROUTE_KEYS.CREATE_BLOG_ROUTE_TAG}/${ROUTE_KEYS.CREATE_BLOG_IMAGE}${search}`,
    Icon: OpeningTimeIcon
  },
  {
    title: 'Preview',
    link: `${ROUTE_KEYS.CREATE_BLOG_ROUTE_TAG}/${ROUTE_KEYS.CREATE_BLOG_PREVIEW}${search}`,
    Icon: OpeningTimeIcon
  }
];
